export const language: any ={
    LabelCarts: "ショッピングカート",
    Material: "材料",
    nodata: "カートにデータがありません"
  }
  

